/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Roby Awaluddin",
  title: "Hi all, I'm Roby",
  subTitle: emoji(
    `I'm a BackEnd Developer with three year of working experience as BackEnd. I graduated from Raharja University with a degree in Informatics Engineering with an interest in BackEnd Developer. Currently work as BackEnd Developer at SALT Indonesia.  I'm eager to make a meaningful impact on the company I work for.`
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/roby-aw",
  linkedin: "https://www.linkedin.com/in/roby-awaluddin",
  gmail: "robyawaluddin@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY BACKEND DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Monitor performance, troubleshoot, and optimize backend processes"
    ),
    emoji("⚡ Ensure reliability, scalability, and efficiency of the backend infrastructure"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    ),
    emoji("⚡ Implement databases (SQL/NoSQL) to manage and store application data"),
    emoji("⚡ Integrate with external services or APIs for additional functionalities")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */
    softwareSkillsIconify: [
      {
        skillName: "MongoDB",
        iconifyClassname: "simple-icons:mongodb"
      },
      {
        skillName: "ElasticSearch",
        iconifyClassname: "simple-icons:elasticsearch"
      },
      {
        skillName: "Redis",
        iconifyClassname: "simple-icons:redis"
      },
      {
        skillName: "Blockchain",
        iconifyClassname: "eos-icons:blockchain"
      },
      {
        skillName: "Swagger",
        iconifyClassname: "simple-icons:swagger"
      },
      {
        skillName: "Mysql",
        iconifyClassname: "simple-icons:mysql"
      },
      {
        skillName: "PostgreSQL",
        iconifyClassname: "akar-icons:postgresql-fill"
      },
      {
        skillName: "Kubernetes",
        iconifyClassname: "mdi:kubernetes"
      }
  ],
  softwareSkills: [
    {
      skillName: "Golang",
      fontAwesomeClassname: "fab fa-golang"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Amazon Web Services",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Raharja University",
      // logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Bachelor of Science in Informatics Engineer.",
      duration: "September 2019 - Nov 2023",
      desc: "Concentrating on Software Engineer With GPA: 3.68",
    },
    {
      schoolName: "SMKN 2 Kab.Tangerang",
      // logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Network Engineering.",
      duration: "July 2016 - Mei 2019",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "DevOps",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Backend Developer",
      company: "SALT Indonesia",
      companylogo: require("./assets/images/SALT.png"),
      date: "June 2024 – Present",
      desc: "A Digital Technology Company dedicated to accelerating your business through digital transformation.",
      descBullets: [
        "Collaborate with other developer",
        "Architect robust, scalable, and high-performance software solutions that meet business needs.",
        "Write clean, maintainable, and well-documented code following best practices and coding standards."
      ]
    },
    {
      role: "Senior BackEnd Developer",
      company: "PT. ICE Messenger Indonesia",
      companylogo: require("./assets/images/indochat.png"),
      date: "August 2022 – June 2024",
      desc: "IndoChat offers free, simple, secure, and reliable instant messaging app for Indonesian.",
      descBullets: [
        "Problem Solving for Team",
        "Perform code reviews and ensure that the code meets the requirements and quality standards",
        "Collaborate with other developer",
        "Architect robust, scalable, and high-performance software solutions that meet business needs.",
        "Write clean, maintainable, and well-documented code following best practices and coding standards."
      ]
    },
    {
      role: "Become a Master of Golang Programme",
      company: "Alterra Academy",
      companylogo: require("./assets/images/alterra.png"),
      date: "February 2022 – July 2022",
      desc: "Student Trainee from alterra academy with kampus merdeka"
    },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/dg.jpeg"),
      projectName: "Dunia Games",
      projectDesc: "The most trusted Gaming News Portal in Indonesia offered by PT Telekomunikasi Selular (Telkomsel)",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://duniagames.co.id"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/tsurvey.jpg"),
      projectName: "TSurvey",
      projectDesc: "An online survey platform managed by Telkomsel. TSurvey can be used to gather input and insights from respondents for various studies.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://tsurvey.id"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/myorbit.png"),
      projectName: "MyOrbit",
      projectDesc: "MyOrbit is a home and portable Wi-Fi service offered by Telkomsel, one of Indonesia's largest cellular providers. offering a flexible alternative to traditional fixed broadband.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://myorbit.id"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/codecert.png"),
      projectName: "CodeCert Certificate",
      projectDesc: "Stampcode, Protect the genuine information to achieve the vision of a world built on trust. SID 9 Code. Best Solution for Encrypting Valuable Information",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.code-cert.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/qtoko.png"),
      projectName: "QToko",
      projectDesc: "Your CRM platform to simplify marketing strategy creation and management, with features: Reward Card, Promo Campaign, Big Data Analytics, and more.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://qtoko.co.id"
        }
      ]
    },
    {
      image: require("./assets/images/chatnews.png"),
      projectName: "Chatnews",
      projectDesc: "Chatnews.id presents a diversity of content and the latest Indonesian news, technology, health, entertainment, sports, football, celebs and lifestyle.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://chatnews.id"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+62 85782260502",
  email_address: "robyawaluddin@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
